if (!customElements.get('layout-header')) {
  customElements.define(
    'layout-header',
    class LayoutHeader extends window.BAO.CustomElement() {
      constructor () {
        super()

        this.state = {
          isTransparent: false,
          isMenuOpen: false,
          isSearchOpen: false,
        }

        this.initialize()
      }

      initialize () {
        this.setupListeners()

        this.toggleMenu = this.toggleMenu.bind(this)
        this.listeners.add(this, 'focusin', this.toggleMenu)
        this.listeners.add(document.body, 'mouseover', this.toggleMenu)

        this.observeHeader()
      }

      setupListeners () {
        window.addEventListener('headerSearch::open', () => {
          this.state.isSearchOpen = true
          this.removeTransparent()

          document
            .querySelector('.aa-PanelBackdrop')
            ?.addEventListener('click', () => {
              this.setTransparent()
            })

          document.querySelector('.aa-Close')?.addEventListener('click', () => {
            this.setTransparent()
          })
        })

        this.addEventListener('mouseenter', () => {
          this.removeTransparent()
        })

        this.addEventListener('mouseleave', event => {
          if (event.relatedTarget?.classList.contains('aa-PanelLayout')) {
            this.removeTransparent()
            return
          }

          if (
            event.relatedTarget?.classList.contains('hd-AnnouncementBar_Body')
          ) {
            this.removeTransparent()
          }
        })
      }

      observeHeader () {
        const transparentOverMeSections = document.querySelectorAll(
          '[data-header-is-transparent-when-over-me]',
        )
        const announcementBarHeight =
          document.querySelector('.hd-AnnouncementBar')?.offsetHeight || 0
        const headerHeight = this.offsetHeight + announcementBarHeight

        const observer = new IntersectionObserver(
          entries => {
            let anyIntersecting = false

            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const rect = entry.boundingClientRect
                const isHeaderOverSection =
                  rect.top < headerHeight && rect.bottom > 0

                if (isHeaderOverSection) {
                  anyIntersecting = true
                }
              }
            })

            if (anyIntersecting) {
              this.setTransparent()
            } else {
              this.removeTransparent()
            }
          },
          {
            root: null,
            rootMargin: `${headerHeight}px 0px -${headerHeight}px 0px`,
            threshold: 0.05, // Small threshold to catch early intersections
          },
        )

        transparentOverMeSections.forEach(section => observer.observe(section))

        // Ensure the header updates on scroll
        window.addEventListener('scroll', () => {
          this.state.isSearchOpen =
            document.querySelector('body').dataset.searchActive === 'true'
          this.checkIfHeaderShouldBeTransparent(
            transparentOverMeSections,
            headerHeight,
          )
        })

        // Initial state check
        this.checkIfHeaderShouldBeTransparent(
          transparentOverMeSections,
          headerHeight,
        )

        window.addEventListener('resize', () => {
          this.state.isSearchOpen =
            document.querySelector('body').dataset.searchActive === 'true'
          this.checkIfHeaderShouldBeTransparent(
            transparentOverMeSections,
            headerHeight,
          )
        })
      }

      checkIfHeaderShouldBeTransparent (
        transparentOverMeSections,
        headerHeight,
      ) {
        if (this.state.isMenuOpen || this.state.isSearchOpen) return

        let anyIntersecting = false

        transparentOverMeSections.forEach(section => {
          const rect = section.getBoundingClientRect()
          const sectionTop = rect.top + window.scrollY
          const sectionBottom = rect.bottom + window.scrollY
          const headerBottom = headerHeight + window.scrollY

          if (sectionTop < headerBottom && sectionBottom > window.scrollY) {
            anyIntersecting = true
          }
        })

        if (anyIntersecting) {
          this.setTransparent()
        } else {
          this.removeTransparent()
        }
      }

      checkInitialState (transparentOverMeSections, headerHeight) {
        let anyIntersecting = false

        transparentOverMeSections.forEach(section => {
          const rect = section.getBoundingClientRect()
          const sectionTop = rect.top + window.scrollY
          const sectionBottom = rect.bottom + window.scrollY
          const headerBottom = headerHeight + window.scrollY

          if (sectionTop < headerBottom && sectionBottom > window.scrollY) {
            anyIntersecting = true
          }
        })

        if (anyIntersecting) {
          this.setTransparent()
        } else {
          this.removeTransparent()
        }
      }

      setTransparent () {
        if (!this.classList.contains('lyt-Header-Transparent')) {
          this.classList.add('lyt-Header-Transparent')
        }
      }

      removeTransparent () {
        if (this.classList.contains('lyt-Header-Transparent')) {
          this.classList.remove('lyt-Header-Transparent')
        }
      }

      toggleMenu (event) {
        const parentMenuItemEl = event.target.closest(
          this.els.menuItem.selector,
        )
        let anyMenuOpen = false
        this.els.menuItem.elements.forEach(menuItemEl => {
          const thisMenuOpen = menuItemEl === parentMenuItemEl
          menuItemEl.setAttribute(
            'aria-expanded',
            menuItemEl === parentMenuItemEl,
          )
          if (thisMenuOpen) {
            this.removeTransparent()
            anyMenuOpen = true
          }
        })

        this.state.isMenuOpen = anyMenuOpen
        this.state.isSearchOpen =
          document.querySelector('body').dataset.searchActive === 'true'

        if (this.state.isSearchOpen) {
          this.removeTransparent()
        }
      }

      get heroSection () {
        return document.querySelector('section-hero')
      }
    },
  )
}
